import { Routes } from '@angular/router';

import { authGuard } from './core/guards/auth.guard';
import { noAuthGuard } from './core/guards/no-auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./layouts/client/client-layout.component').then((m) => m.ClientLayoutComponent),
    children: [
      {
        path: '',
        loadChildren: () => import('./features/client/client.routes').then((m) => m.clientRoutes),
      },
    ],
  },
  {
    path: 'admin',
    canActivate: [noAuthGuard],
    loadChildren: () => import('./features/auth/auth.routes').then((m) => m.authRoutes),
  },
  {
    path: 'staff',
    loadComponent: () =>
      import('./layouts/staff/staff-layout.component').then((m) => m.StaffLayoutComponent),
    canActivate: [authGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'categories',
      },
      {
        path: 'categories',
        loadChildren: () =>
          import('./features/categories/categories.routes').then((m) => m.categoriesRoutes),
      },
      {
        path: 'questions',
        loadChildren: () =>
          import('./features/questions/questions.routes').then((m) => m.questionsRoutes),
      },
      {
        path: 'characters',
        loadChildren: () =>
          import('./features/characters/characters.routes').then((m) => m.charactersRoutes),
      },
      {
        path: 'reactions',
        loadChildren: () =>
          import('./features/reactions/reactions.routes').then((m) => m.reactionsRoutes),
      },
      {
        path: 'banners',
        loadChildren: () =>
          import('./features/banners/banners.routes').then((m) => m.bannersRoutes),
      },
      {
        path: 'tournaments',
        loadChildren: () =>
          import('./features/tournaments/tournaments.routes').then((m) => m.tournamentsRoutes),
      },
      {
        path: 'notifications',
        loadChildren: () =>
          import('./features/notifications/notifications.routes').then(
            (m) => m.notificationsRoutes,
          ),
      },
      {
        path: 'subscriptions',
        loadChildren: () =>
          import('./features/subscriptions/subscriptions.routes').then(
            (m) => m.subscriptionsRoutes,
          ),
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./features/settings/settings.routes').then((m) => m.settingsRoutes),
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
